
/*=========================================================================================
  File Name: modulekaindsGetters.js
  Description: kainds Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  getKinds: state => (id) => state.kinds.find(user => user.id === id)
}
